import { Component, OnInit } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { SolicitudesService } from "../../../funcionario/solicitudes/solicitudes.service";
import { ReversarEstadoService } from "./reversar-estado.service";
import { DetalleSolicitudService } from "../../../funcionario/detalle-solicitud/detalle-solicitud.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ModalEditarEstadoComponent } from "src/app/components/core/layouts/modal-editar-estado/modal-editar-estado.component";
import { ModalConfirmarRespuestaComponent } from "src/app/shared/layouts/modal-confirmar-respuesta/modal-confirmar-respuesta.component";
import {
  ConfirmarRespuestaModel,
  ConfirmarRespuestaType,
} from "src/app/shared/models/confirmar-respuesta.model";
import { AlertType } from "src/app/shared/models/alert.model";
import { AlertsService } from "src/app/shared/services/alerts.service";
import { ConfirmeValidators } from "src/app/shared/directives/validators/confirme-validators";

@Component({
  selector: "app-reversar-estado",
  templateUrl: "./reversar-estado.component.html",
  styleUrls: ["./reversar-estado.component.scss"],
})
export class ReversarEstadoComponent implements OnInit {
  descripcion: string;
  headers: Array<string>;
  formDatos: FormGroup;
  formObservacion: FormGroup;
  estados: Array<any>;
  datosRnt: any;
  labelText: string;

  constructor(
    private formBuilder: FormBuilder,
    private detalleServices: DetalleSolicitudService,
    private modalService: NgbModal,
    private reversarEstadoService: ReversarEstadoService,
    private alertService: AlertsService
  ) {}

  ngOnInit() {
    this.formulario();
    this.setSelectedFilter();
    this.headers = ["Número RNT", "Establecimiento", "Estado RNT", "Acciones"];
  }

  formulario() {
    this.formDatos = this.formBuilder.group({
      codigo: ["", [Validators.required, ConfirmeValidators.numberValidator]],
      tipo_filtro: [1, Validators.required],
    });

    this.formObservacion = this.formBuilder.group({
      observacion: ["", Validators.required],
    });
  }

  getRnt() {
    this.reversarEstadoService
      .getConsultaUltimaSolicitud({
        codigo: this.formDatos.value.codigo,
        tipo_filtro: this.formDatos.value.tipo_filtro,
      })
      .subscribe((resultado) => {
        if (resultado.result) {
          this.datosRnt = resultado.data ? resultado.data[0] : null;
          if (!this.datosRnt.estado_valido) {
            this.alertService.alert(
              resultado.control.alert_type as AlertType,
              resultado.control.message,
              `/Solicitud/ConsultaUltimaSolicitud/${this.formDatos.value.codigo}`,
              resultado.control.code.toString(),
              true
            );
          }
        }
      });
  }

  reversarEstado() {
    this.reversarEstadoService
      .getEstadosPorTipoSolicitudReversion({
        tipo_solicitud_id: this.datosRnt.tipo_solicitud_id,
        estado_solicitud_id: this.datosRnt.estado_solicitud_id,
      })
      .subscribe((resultado) => {
        if (resultado.result) {
          this.estados = resultado.data;
          this.detalleServices
            .getDecripciones(this.datosRnt.sub_categoria_id)
            .subscribe((res) => {
              if (res.result) {
                this.descripcion = res.data.descripcion_requisitos;
                this.onOpenModalStatus();
              }
            });
        }
      });
  }

  onOpenModalStatus() {
    const modalRef = this.modalService.open(ModalEditarEstadoComponent, {
      centered: true,
      size: "xl",
      backdropClass: "light-blue-backdrop",
    });
    modalRef.componentInstance.estados = this.estados;
    modalRef.componentInstance.descripcion = this.descripcion;
    modalRef.result.then((resultado) => {
      const modalRef_2 = this.modalService.open(
        ModalConfirmarRespuestaComponent,
        { centered: true }
      );
      const confirmarRespuesta = {} as ConfirmarRespuestaModel;
      confirmarRespuesta.type = ConfirmarRespuestaType.Atencion;
      confirmarRespuesta.message = `¿Está seguro de cambiar el estado de la solicitud a ${resultado.estado_descripcion}?`;
      modalRef_2.componentInstance.confirmarRespuesta = confirmarRespuesta;
      modalRef_2.result.then(() => {
        this.datosRnt.observaciones = resultado.observaciones.replace(
          new RegExp("\r?\n", "g"),
          "<br />"
        );
        this.datosRnt.estado_solicitud_anterior_id = this.datosRnt.estado_solicitud_id;
        this.datosRnt.estado_posterior_id = resultado.estado_posterior_id;
        this.datosRnt.motivo_devolucion_id = resultado.motivo_devolucion_id;
        this.reversarEstadoService
          .changeRevertirEstado({
            ...this.datosRnt,
            descripcion_estado_solicitud: resultado.estado_descripcion,
            descripcion_tipo_solicitud: this.datosRnt.tipo_solicitud,
          })
          .subscribe((res) => {
            if (res.result) {
              this.estados = null;
              this.descripcion = null;
              this.datosRnt = null;
              this.formDatos = this.formBuilder.group({
                codigo: [
                  "",
                  [Validators.required, ConfirmeValidators.numberValidator],
                ],
                tipo_filtro: [1, Validators.required],
              });
            }
          });
      });
    });
  }

  setSelectedFilter(): void {
    switch (this.formDatos.get("tipo_filtro").value) {
      case 1:
        this.labelText = "Ingrese el número de RNT";
        break;
      case 2:
        this.labelText = "Ingrese el número de Radicado";
        break;
      default:
        this.labelText = "Seleccione un filtro";
        break;
    }
  }
}
